import styled from 'styled-components';
import { TokenName } from '@mewssystems/design-tokens';
import { getTextTokenPreset, getToken } from '@optimus-web/common';

export const Affix = styled.div<{ $disabled?: boolean }>`
    ${getTextTokenPreset('BODY_M')};
    color: ${({ $disabled }) =>
        $disabled ? getToken(TokenName.TEXT_DISABLED) : getToken(TokenName.TEXT_STATIC_SECONDARY)};
`;
